import { WidgetType } from 'domain/entity/widget';
import { WidgetIssueSeverity } from 'domain/entity/widgetIssue';

const I18N_NAMESPACE = 'reports.widgetIssues';

export const WIDGET_ISSUE_I18N = {
    drawerTitle: `${I18N_NAMESPACE}.drawerTitle`,
    howToFix: `${I18N_NAMESPACE}.howToFix`,
    closeAriaLabel: `${I18N_NAMESPACE}.closeAriaLabel`,
    badgeAriaLabel: `${I18N_NAMESPACE}.badgeAriaLabel`,
    page: `${I18N_NAMESPACE}.page`,
    severity: (severity: WidgetIssueSeverity): string => `${I18N_NAMESPACE}.severity.${severity}`,
    widgetType: (type: WidgetType): string => `${I18N_NAMESPACE}.widgetType.${type}`,
} as const;

export const WIDGET_ISSUE_ICON = {
    error: 'error',
    warning: 'warning',
    info: 'circle_info',
} as const;
